export default class FileService {
    
    public async fetchFile(url: string): Promise<ArrayBuffer | null> {
        try {
            const fileExists = await this.isFileExists(url)
            if (!fileExists) return null

            const response = await fetch(url, {
                headers: { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
            })

            return response.arrayBuffer()
        } catch (error) {
            console.error('error getOlympiadStatisticRussia', error)
            return null
        }
    }

    public async isFileExists(path: string): Promise<boolean> {
        const headResponse = await fetch(path, { method: 'HEAD' })
        return headResponse.status === 200
    }
}
